import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { Router, Link } from "@reach/router";
import Divider from "@material-ui/core/Divider";
import { withSnackbar } from "notistack";
import SERVER_ADDRESS from "../../../config";
import RadarGradeChart from "./RadarGradeChart";
import PieGradeChart from "./PieGradeChart";
import GradeList from "./GradeList";
import GoujianTestTable from "./GoujianTestTable";

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  divider: {
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.light
  },
  typography: {
    marginTop: theme.spacing(4)
  },
  paper: {
    width: "100%",
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  chart: {
    margin: "auto"
  }
}));

function StudentGradePage(props) {
  const classes = useStyles();
  const { grades, averageGrade } = props;
  console.log("hello");
  return (
    <>
      {grades.length > 0 && (
        <>
          <Grid container spacing={1}>
            <Grid
              container
              item
              xs={12}
              component={Paper}
              className={classes.paper}
              justify="center"
            >
              <Typography
                variant="h5"
                gutterBottom
                color="secondary"
                className={classes.typography}
              >
                我的成绩分布
              </Typography>
              <Grid item xs={12}>
                <RadarGradeChart
                  gradeData={grades}
                  averageGrade={averageGrade}
                />
              </Grid>
              <Typography
                variant="h5"
                gutterBottom
                color="secondary"
                className={classes.typography}
              >
                我完成的实验次数
              </Typography>
              <Grid item xs={12}>
                <PieGradeChart gradeData={grades} />
              </Grid>
            </Grid>
            <Divider variant="fullWidth" className={classes.divider} light />

            <Grid
              container
              item
              xs={12}
              component={Paper}
              className={classes.paper}
              justify="center"
            >
              <Typography
                variant="h5"
                gutterBottom
                color="secondary"
                className={classes.typography}
              >
                我的实验成绩详情
              </Typography>
              <GradeList gradeData={grades} />
            </Grid>

            {/* <Grid
              container
              item
              xs={12}
              component={Paper}
              className={classes.paper}
              justify="center"
            >
              <Typography
                variant="h5"
                gutterBottom
                color="secondary"
                className={classes.typography}
              >
                我的构件辨识实验正误分布
              </Typography>
              <GoujianTestTable gradeData={grades} />
            </Grid> */}
          </Grid>
        </>
      )}
    </>
  );
}

export default StudentGradePage;
